import { render, staticRenderFns } from "./header-menu-item.vue?vue&type=template&id=77a47b71&scoped=true"
import script from "./header-menu-item.ts?vue&type=script&lang=ts&external"
export * from "./header-menu-item.ts?vue&type=script&lang=ts&external"
import style0 from "./header-menu-item.less?vue&type=style&index=0&id=77a47b71&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a47b71",
  null
  
)

export default component.exports